// extracted by mini-css-extract-plugin
export default {"ClockPage":"ClockPage_ClockPage__9Sqiy","ClockPage__left":"ClockPage_ClockPage__left__i6XKm","ClockPage__mainBtn":"ClockPage_ClockPage__mainBtn__4cyE3"};